import './Typing.sass';

import React, { FC } from 'react';

import { classNames as cn } from '$utils';
import { useTranslator } from '$hooks';
import { LottieIcon } from '$uikit';

export const Typing: FC<{ className?: string }> = ({ className }) => {
  const t = useTranslator();
  return (
    <div className={cn('Typing', className)}>
      <LottieIcon name="typing" width={27} height={18} loop={true} />
      {t('typing')}
    </div>
  );
};
